import i18n from 'config/i18n';
import { addDays, parseISO } from 'date-fns';
import * as yup from 'yup';

import type { OpeningScheduleResponse } from 'generated/index';
import { getLocale } from 'utils/date';

import { scheduleValidityFields } from '../OpeningScheduleForm/OpeningScheduleForm.schema';

const t = i18n.getFixedT(getLocale(), 'common', 'planUnitHome.openingHours');

/**
 * Name and validity, as a schedule has them. The copy has to start after the original's first day:
 * the original ends where the copy starts, and ending it on or before its first day would leave it
 * valid on no day. The backend refuses that too; here the field says so straight away.
 */
export const copySchema = (source: OpeningScheduleResponse | undefined) =>
  yup.object({
    ...scheduleValidityFields,
    validFrom: source
      ? scheduleValidityFields.validFrom.min(
          addDays(parseISO(source.validFrom), 1),
          t('errors.copyStartNotAfterSource')
        )
      : scheduleValidityFields.validFrom
  });
